export enum PermissionCategory {
  Corporate = 'Corporate',
  Facility = 'Facility',
  User = 'User',
  Billing = 'Billing',
  Reports = 'Reports',
  Settings = 'Settings'
}
